import { useState } from "react";
import { useParams } from "react-router-dom";
import DataJurnal from "../../components/dataSekolah/Jurnal/DataJurnal";
import JurnalGuruKepsek from "../../components/dataSekolah/Jurnal/JurnalGuruKepsek";
import AbsenGuru from "../Absen/AbsenGuru";
import KurikulumPdf from "../Kuikulum/KurikulumPdf";
import TarafSerap from "../Tarafserap/TarafSerap";
import ProfileKepsek from "./ProfileKepsek";

const TampilanKepsek = () => {
  const { id } = useParams();
  const [menuAktif, setMenuAktif] = useState("Absen");

  const menuList = [
    { key: "Absen", label: "Absen Murid" },
    { key: "Absen guru", label: "Absen Guru & Staff" },
    { key: "kurikulum", label: "Kurikulum" },
    { key: "jurnalguru", label: "Jurnal Guru" },
    { key: "tarafSerap", label: "Taraf Serap" },
    { key: "jurnal", label: "Jurnal Kepala Sekolah" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* HEADER */}
        <div className="bg-white rounded-2xl shadow-md p-6 mb-6 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
            Dashboard Kepala Sekolah
          </h1>
          <p className="text-gray-500 mt-2 text-sm md:text-base">
            Monitoring dan Pengelolaan Data Sekolah
          </p>
        </div>

        {/* MENU */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
          {menuList.map((menu) => (
            <button
              key={menu.key}
              onClick={() => setMenuAktif(menu.key)}
              className={`p-3 rounded-xl text-sm md:text-base font-semibold transition-all duration-300 shadow-sm
                ${
                  menuAktif === menu.key
                    ? "bg-blue-600 text-white scale-105 shadow-md"
                    : "bg-white hover:bg-blue-100 text-gray-700"
                }`}
            >
              {menu.label}
            </button>
          ))}
        </div>

        {/* CONTENT */}
        <div className="bg-white rounded-2xl shadow-lg p-4 md:p-6 transition-all duration-300">
          {menuAktif === "Absen" && <ProfileKepsek />}
          {menuAktif === "Absen guru" && <AbsenGuru />}
          {menuAktif === "jurnal" && <DataJurnal id={id} />}
          {menuAktif === "tarafSerap" && <TarafSerap />}
          {menuAktif === "kurikulum" && <KurikulumPdf />}
          {menuAktif === "jurnalguru" && <JurnalGuruKepsek />}
        </div>
      </div>
    </div>
  );
};

export default TampilanKepsek;
